import { create } from "zustand";

const ZustandValidationConjugue = create((set, get) => ({
  buttonIsAtivo: false,
  nomeConjugue: "",
  rendaConjugue: "",
  nascimentoConjugue: "",
  secondErro: false,

  nomeConjugueIsErro: false,
  nascimentoConjugueIsErro: false,
  rendaConjugueIsErro: false,

  setnomeConjugueIsErro: (value) => set({ nomeConjugueIsErro: value }),
  
  setNascimentoConjugueIsErro: (value) =>
    set({ nascimentoConjugueIsErro: value }),

  setRendaConjugueIsErro: (value) => set({ rendaConjugueIsErro: value }),

  setRendaConjugue: (value) => set({ rendaConjugue: value || "" }),
  setButtonIsAtivo: (value) => set({ buttonIsAtivo: value }),
  setNomeConjugue: (value) => set({ nomeConjugue: value || "" }),
  setNascimentoConjugue: (value) => set({ nascimentoConjugue: value || "" }),
  setSecondErro: (value) => set({ secondErro: value }),
}));

export default ZustandValidationConjugue;
